import React, { useState, useEffect } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { useTranslations } from '../hooks/useTranslations';
import { useLanguage } from '../contexts/LanguageContext';

function Settings() {
  const [userData, setUserData] = useState(null);
  const { t } = useTranslations();
  const { currentLanguage, changeLanguage } = useLanguage();

  // Функция форматирования даты
  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const monthKeys = [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december'
    ];

    const monthKey = monthKeys[date.getMonth()];
    const monthName = t(`settings.months.${monthKey}`);
    
    if (currentLanguage === 'ru') {
      return `${date.getDate()} ${monthName} ${date.getFullYear()} года`;
    } else {
      return `${monthName} ${date.getDate()}, ${date.getFullYear()}`;
    }
  };

  // Загрузка данных пользователя
  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: {
            "token": JSON.parse(token)
          }
        });

        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <div className="">

      <div className="bg-white rounded-3xl md:p-8 p-4 shadow-sm">

        <div className="flex md:flex-row flex-col md:items-center md:pb-8 pb-4 justify-between border-b border-gray-200">
          <h1 className="text-xl font-bold ">{t('settings.accountInfo')}</h1>
          <div className="flex items-center mt-4 md:mt-0 space-x-2">
            <InformationCircleIcon className="w-4 h-4 text-primary" />
            <p className="text-gray-500 text-[12px]">{t('settings.accountCreated')} {formatDate(userData?.created_at)}</p>
          </div>
        </div>

        <div className="flex items-start space-x-8 md:mt-8 mt-4">
          {/* Информация о пользователе */}
          <div className="flex-1">

            <div className="space-y-4">
              <div>
                <label className="block text-[12px] font-medium text-gray-500 mb-1">
                  {t('settings.firstName')}
                </label>
                <p className="text-gray-900 font-medium">{userData?.username || t('settings.notSpecified')}</p>
              </div>

              <div>
                <label className="block text-[12px] font-medium text-gray-500 mb-1">
                  {t('settings.lastName')}
                </label>
                <p className="text-gray-900 font-medium">{userData?.lastname || t('settings.notSpecified')}</p>
              </div>

              <div>
                <label className="block text-[12px] font-medium text-gray-500 mb-1">
                  {t('settings.email')}
                </label>
                <p className="text-gray-900 font-medium">{userData?.email || t('settings.notSpecified')}</p>
              </div>

              <div>
                <label className="block text-[12px] font-medium text-gray-500 mb-1">
                  {t('settings.phone')}
                </label>
                <p className="text-gray-900 font-medium">{userData?.contact || t('settings.notSpecified')}</p>
              </div>

              {/* Language Settings */}
              <div className="pt-4 border-t border-gray-200">
                <label className="block text-[12px] font-medium text-gray-500 mb-1">
                  {t('settings.language')}
                </label>
                <p className="text-gray-600 text-[11px] mb-3">
                  {t('settings.languageDescription')}
                </p>
                <div className="flex space-x-2">
                  <button
                    onClick={() => changeLanguage('ru')}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      currentLanguage === 'ru'
                        ? 'bg-primary text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    Русский
                  </button>
                  <button
                    onClick={() => changeLanguage('en')}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      currentLanguage === 'en'
                        ? 'bg-primary text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    English
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings; 